import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ShieldCheck } from 'lucide-react';

export const ProtectedRoute = ({ children, roles }) => {
  const { user, isLoading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 gap-3" data-testid="auth-loading">
        <div className="w-12 h-12 bg-[#0f392b] rounded-lg flex items-center justify-center animate-pulse">
          <ShieldCheck className="w-6 h-6 text-white" />
        </div>
        <p className="text-sm text-slate-500">Verifying session...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Force password change on first sign-in (admin-seeded temp password)
  if (user.must_change_password && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  if (roles && !roles.includes(user.role)) {
    // Customer-portal users get bounced to the portal instead of a scary "forbidden" screen.
    if (user.role === 'customer' && location.pathname !== '/portal') {
      return <Navigate to="/portal" replace />;
    }
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="forbidden-page">
        <div className="max-w-md text-center space-y-3">
          <h1 className="text-2xl font-heading font-bold text-slate-900">Access denied</h1>
          <p className="text-sm text-slate-600">
            Your role ({user.role}) does not have permission to view this page.
          </p>
        </div>
      </div>
    );
  }

  return children;
};
